import { MAX_WORKSPACE_ITEMS } from '~teacher/components/workspaces/WorkspaceQuizzes/actions/constants';

function isOverWorkspaceItemLimit(
  workspaceItems: Array<unknown>,
  limit: number
) {
  return workspaceItems.length > limit;
}

export function isOverQuizLimit(quizzes: Array<unknown>) {
  return isOverWorkspaceItemLimit(quizzes, MAX_WORKSPACE_ITEMS);
}

export function isOverFolderLimit(folders: Array<unknown>) {
  return isOverWorkspaceItemLimit(folders, MAX_WORKSPACE_ITEMS);
}
